import StyleSheet from "../../lib/utils/StyleSheet"
const image = StyleSheet.createVariants({
  default: {},
})

export default {
  image,
}
